import { Link } from 'react-router-dom'
import { useUser } from '../../contexts/UserContext'

/**
 * MobileHeader - Top header bar for mobile devices
 *
 * Shows hamburger menu, logo, and user avatar
 * Only visible on mobile (hidden on lg+)
 */
export default function MobileHeader({ onMenuClick }) {
  const { user } = useUser()

  return (
    <header className="lg:hidden fixed top-0 left-0 right-0 z-30 h-14 bg-slate-900 border-b border-slate-800 px-4 flex items-center justify-between">
      {/* Hamburger Button */}
      <button
        onClick={onMenuClick}
        className="p-2 -ml-2 text-slate-400 hover:text-white rounded-lg transition-colors"
        aria-label="Open menu"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      {/* Logo */}
      <Link to="/" className="flex items-center gap-2">
        <img
          src="/shield-logo.png"
          alt="IceOps"
          className="h-8 w-auto"
        />
        <span className="text-lg font-bold text-white">IceOps</span>
      </Link>

      {/* User Avatar */}
      <Link
        to="/settings"
        className="w-8 h-8 rounded-full bg-ice-600 flex items-center justify-center text-white font-semibold text-sm"
      >
        {(user?.name || user?.email || 'U')[0].toUpperCase()}
      </Link>
    </header>
  )
}
